import { BASE_URL_LEGACY } from "./";

export const rankingsService = {
  getWeeklyDetail,
  getMonthlyDetail,
};

function getWeeklyDetail(user, timestamp) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };

  return fetch(
    `${BASE_URL_LEGACY}/energy_info/user_rankings/?user_id=${user.user_id}&timestamp=${timestamp}&timescale=week`,
    requestOptions
  )
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then((detail) => {
      return detail;
    });
}

function getMonthlyDetail(user, timestamp) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };

  return fetch(
    `${BASE_URL_LEGACY}/energy_info/user_rankings/?user_id=${user.user_id}&timestamp=${timestamp}&timescale=month`,
    requestOptions
  )
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then((detail) => {
      return detail;
    });
}

// function handleResponse(response) {
//   if (!response.ok) {
//     return Promise.reject(response.statusText);
//   }
//
//   return response.json();
// }
